'use client';
import Box from '@mui/material/Box';
import { type SxProps, type Theme } from '@mui/material/styles';
import React from 'react';

interface InsightAppLogoProps {
  height?: number;
  /** fill color; defaults to the official brand orange */
  fill?: string;
  sx?: SxProps<Theme>;
}

/**
 * The official ProGlove Insight app icon (orange swirl), inlined from
 * img/insight-app-icon.svg so it can be recolored via `fill`.
 */
export default function InsightAppLogo({ height = 16, fill = '#FF6F19', sx }: InsightAppLogoProps): React.JSX.Element {
  return (
    <Box component="span" sx={{ display: 'inline-flex', lineHeight: 0, flexShrink: 0, ...sx }}>
      <svg height={height} viewBox="0 0 256 256" fill="none" role="img" aria-label="Insight App">
        <path
          d="M0.156441 142.687C-1.23637 131.341 6.8273 121.02 18.1164 119.703C29.4056 118.312 39.6684 126.437 40.9879 137.71V137.783C42.3808 149.129 34.3171 159.377 23.0279 160.768C22.0017 160.914 20.9754 160.914 19.9491 160.914C9.90615 160.621 1.40264 153.009 0.156441 142.687ZM19.8025 106.087C9.24639 101.842 4.18827 89.7637 8.44003 79.1496C12.6185 68.5356 24.6407 63.4116 35.1968 67.6572C45.7528 71.9028 50.8109 83.9077 46.5592 94.5217C43.2604 102.793 35.1968 107.771 26.9132 107.551C24.4941 107.551 22.1483 107.039 19.8025 106.087ZM43.1871 56.6772C36.0031 47.82 37.2493 34.7903 45.9727 27.4703C54.7695 20.2235 67.6713 21.4679 75.002 30.2519C82.186 39.1091 80.9398 52.1388 72.2163 59.4588C68.1845 62.7528 63.3463 64.29 58.5814 64.1436C52.7902 63.9972 47.1456 61.5084 43.1871 56.6772ZM87.2441 24.5423C85.1182 13.2695 92.4488 2.50903 103.591 0.386219C114.734 -1.80979 125.51 5.58343 127.636 16.8563C129.762 28.1291 122.358 38.8895 111.288 41.0123C109.822 41.3051 108.283 41.3783 106.89 41.3783C97.4336 41.0855 89.0767 34.2779 87.2441 24.5423Z"
          fill={fill}
        />
        <path
          d="M123.656 255.951C97.5571 255.219 71.3844 246.506 49.1706 229.299C38.1737 220.806 28.7163 210.701 21.0918 199.352C14.7136 189.907 17.2062 177.02 26.5903 170.577C35.9743 164.207 48.8041 166.623 55.1823 176.142C60.3875 183.83 66.7657 190.712 74.3169 196.497C112.44 226.004 167.351 218.755 196.749 180.389C210.972 161.791 217.13 138.727 214.125 115.443C211.119 92.1592 199.242 71.5113 180.767 57.2335C173.289 51.4492 165.078 46.9828 156.281 43.9076C145.577 40.1734 139.859 28.3119 143.598 17.5486C147.337 6.71216 159.067 1.07427 169.844 4.80846C182.82 9.34806 194.917 15.9378 205.84 24.4313C233.039 45.4452 250.414 75.9045 254.886 110.098C259.359 144.291 250.268 178.265 229.3 205.649C203.201 239.696 163.392 257.049 123.656 255.951Z"
          fill={fill}
        />
        <circle cx="125.806" cy="124.343" r="38.0343" fill={fill} />
      </svg>
    </Box>
  );
}
